import ToolMark from '../../tools/ToolMark';
// Toggles an underline mark on the currently selected elements.

class ToolUnderline extends ToolMark {
  static toolName = 'Underline';
  static iconClass = 'fa-regular fa-underline';
  static mark = 'underline' as const;
  static shortcut = 'Cmd+u';
}

export default ToolUnderline;
